import React, { useContext, useEffect, useRef } from 'react';
import {
  DetailContext,
  DetailHandle,
  DetailMode,
  EvidenceContext,
} from '@eas/common-web';
import { DraftField } from '@composite/drafts/draft-field';
import { EsFile } from '@models';
import { EvidenceApiUrl, UIElement } from '@enums';
import { DRAFT_SOURCE } from '../../../es-file/es-file-hooked-sources';
import { useSprFilePermission } from '../../../es-file/es-file-permission';

export function DraftsFields() {
  const { hookedSources } = useContext(EvidenceContext);
  const { isLocked, mode, source } =
    useContext<DetailHandle<EsFile>>(DetailContext);

  const { hasPermission } = useSprFilePermission(source.data);
  const loadedDraftsFor = useRef<string>();

  // eslint-disable-next-line prettier/prettier
  const disabledDrafts =
    isLocked ||
    mode !== DetailMode.VIEW ||
    !hasPermission(UIElement.SprFile.DRAFTS);
  const draftSource = hookedSources[DRAFT_SOURCE]?.source;

  useEffect(() => {
    const id = source.data?.id;

    if (
      draftSource &&
      id &&
      (loadedDraftsFor.current !== id || !draftSource.isDataValid())
    ) {
      loadedDraftsFor.current = id;
      draftSource.setUrl(`${EvidenceApiUrl.ES_FILES}/${id}/draft/list`);
      draftSource.reset();
      draftSource.loadMore();
    }
  }, [draftSource, source.data?.id]);

  return (
    <>
      <DraftField disabled={disabledDrafts} source={draftSource} />
    </>
  );
}
